<template>
  <div id="cust_resetpassword">   
    <ResetPasswordComponent></ResetPasswordComponent>     
  </div>
</template>

<script>

  import ResetPasswordComponent from '@/components/cust_components/reset_password_component.vue';
  
  export default {
      name: 'resetpassword',
      data() {
          return {
          }
      },
      components: {     
        ResetPasswordComponent,
      }
  }
</script>